import { styled } from '@raskrask-dk/rr-components'

export const StyledPackageInformation = styled('div', {
    bgc: '$primary200',
    border: '1px solid $primary400',
    br: 4,
    p: 32,
})
